/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class CrossIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g id="cross">
        <g
          id="Group-21"
          transform="translate(5.000000, 5.000000)"
        >
          <polygon
            id="Rectangle-52"
            transform="translate(6.545164, 6.961551) rotate(-43.000000) translate(-6.545164, -6.961551) "
            points="5.28029582 -0.499640961 7.28029582 -0.499640961 7.81003194 14.3571587 5.68454888 14.4227429"
          />
          <polygon
            id="Rectangle-52"
            transform="translate(6.449243, 6.967486) rotate(-316.000000) translate(-6.449243, -6.967486) "
            points="5.57924404 -0.485972805 7.57924404 -0.485972805 7.46268446 14.4209442 5.31924163 14.345339"
          />
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(CrossIcon);
Icon.displayName = 'CrossIcon';
export default Icon;
